<template>
  <div>
    <b-modal
      size="lg"
      v-model="visible"
    >
    <template slot="modal-title">
      {{titulo}}
    </template>

      <div>
        <b-row>
          <b-col lg="12">
            <b-form>
              <b-card-body>
                <b-row>
                  <b-col sm="6">
                    <!--
                    <b-form-group
                      :label="crearLabel('Nombre', 'gspnombre', 'datosFormulario')"
                      label-for="gspnombre">
                      <b-form-input
                        id="gspnombre"
                        type="text"
                        placeholder=""
                        v-model="datosFormulario.gspnombre"
                        :disabled="campoBloqueado('gspnombre', 'datosFormulario')"
                        @change="validarCampo('pkg_genpp_procedimientos', 'gspnombre', $event, 'datosFormulario')">
                      </b-form-input>
                      <span class="error-validacion-campo">
                          {{ mensajeValidacionCampo.gspnombre }}
                      </span>
                    </b-form-group>
                    -->
                    <b-form-group
                      :label="crearLabel('Descripción', 'gspdescripcion', 'datosFormulario')"
                      label-for="gspdescripcion">
                      <b-form-input
                        id="gspdescripcion"
                        type="text"
                        placeholder=""
                        v-model="datosFormulario.gspdescripcion"
                        :disabled="campoBloqueado('gspdescripcion', 'datosFormulario')"
                        @change="validarCampo('pkg_genpp_procedimientos', 'gspdescripcion', $event, 'datosFormulario')">
                      </b-form-input>
                      <span class="error-validacion-campo">
                          {{ mensajeValidacionCampo.gspdescripcion }}
                      </span>
                    </b-form-group>

                    <b-form-group
                      :label="crearLabel('Tipo', 'gsptipo', 'datosFormulario')"
                      label-for="gsptipo">
                      <b-form-select 
                        :options="valTipo"
                        v-model="datosFormulario.gsptipo"
                        :disabled="campoBloqueado('gsptipo', 'datosFormulario')"
                        
                      >
                      </b-form-select>
                     
                      <span class="error-validacion-campo">
                        {{ mensajeValidacionCampo.gsptipo }}
                      </span>
                    </b-form-group>

                  </b-col>
                  <!--
                  <b-col sm="6">  
                    
                    <b-form-group
                      :label="crearLabel('Glosa Clave 1', 'gspclave1', 'datosFormulario')"
                      label-for="gspclave1">
                      <b-form-input
                        id="gspclave1"
                        type="text"
                        placeholder=""
                        v-model="datosFormulario.gspclave1"
                        :disabled="campoBloqueado('gspclave1', 'datosFormulario')"
                        @change="validarCampo('pkg_genpp_procedimientos', 'gspclave1', $event, 'datosFormulario')">
                      </b-form-input>
                      <span class="error-validacion-campo">
                          {{ mensajeValidacionCampo.gspclave1 }}
                      </span>
                    </b-form-group>

                    <b-form-group
                      :label="crearLabel('Glosa Clave 2', 'gspclave2', 'datosFormulario')"
                      label-for="gspclave2">
                      <b-form-input
                        id="gspclave2"
                        type="text"
                        placeholder=""
                        v-model="datosFormulario.gspclave2"
                        :disabled="campoBloqueado('gspclave2', 'datosFormulario')"
                        @change="validarCampo('pkg_genpp_procedimientos', 'gspclaves', $event, 'datosFormulario')">
                      </b-form-input>
                      <span class="error-validacion-campo">
                          {{ mensajeValidacionCampo.gspclave2 }}
                      </span>
                    </b-form-group>

                    <b-form-group
                      :label="crearLabel('Glosa Clave 3', 'gspclave3', 'datosFormulario')"
                      label-for="gspclave3">
                      <b-form-input
                        id="gspclave3"
                        type="text"
                        placeholder=""
                        v-model="datosFormulario.gspclave3"
                        :disabled="campoBloqueado('gspclave3', 'datosFormulario')"
                        @change="validarCampo('pkg_genpp_procedimientos', 'gspclaves', $event, 'datosFormulario')">
                      </b-form-input>
                      <span class="error-validacion-campo">
                          {{ mensajeValidacionCampo.gspclave3 }}
                      </span>
                    </b-form-group>
                    
                  </b-col>
                  -->
                </b-row>
              </b-card-body>
            </b-form>
          </b-col>
        </b-row>
      </div>
      <div
        slot="modal-footer"
        class="w-100"
      >
        <p class="float-left"></p>
        <b-button
          type="submit"
          variant="primary"
          class="float-right"
          style="margin-right:8px;"
          @click="guardarProceso"
        > Guardar</b-button>

         <b-button
          type="submit"
          variant="secondary"
          class="float-right"
          style="margin-right:8px;"
          @click="modalEditarProceso = false; visible = false;"
        >Cancelar</b-button>

      </div>
    </b-modal>
  
  </div>
</template>
<script>

import axios from "axios";
import apiActividades from "@/components/services/apiActividades";
import { globalesMixin } from "../../components/mixins/globalesMixin";

export default {
  name: "EditarProceso",
  mixins: [globalesMixin],
  data: function() {
    return {
      titulo: "",
      visible: false,
      modalEditarProceso: false,
      modalAgregarProceso: false,
      datosFormulario: {
        gspnombre: "",
        gspdescripcion: "",
        gspclave1: "",
        gspclave2: "",
        gspclave3: "",
        gspiniestado: "",
        gspiniactivi: ""
      },
      valTipo: [],
      datosFormularioEstado: [],
      mensajeValidacionCampo: {}
    };
  },
  methods: {
    obtenerProceso(mail, usuario, id, tiporec) {
      this.titulo = "Editar Tarea";
      this.mensajeValidacionCampo = {};
      return apiActividades
        .buscarProcedimiento(mail, usuario, id, tiporec)
        .then(response => {

          this.datosFormulario.gspnombre = "";
          this.datosFormulario.gspdescripcion = "";
          this.datosFormulario.gspclave1 = "";
          this.datosFormulario.gspclave2 = "";
          this.datosFormulario.gspclave3 = "";
          this.datosFormulario.gspiniestado = "";
          this.datosFormulario.gspiniactivi = "";

          response.data = this.keysMinuscula(response.data);
          this.datosFormulario = response.data.res[0];
          this.datosFormularioEstado = response.data.festado;

          //Carga lista de tipo 
          var tiposTipo = new Array();
          var lista_tipos = response.data.tipos;
          for(var i = 0; i < lista_tipos.length; i++){
              var obj = new Object();
              obj.value = lista_tipos[i]["gsptipo"];
              obj.text = lista_tipos[i]["desc_tipo"];
              tiposTipo.push(obj);
          }
          this.valTipo = tiposTipo;

          this.modalEditarProceso = true;
          this.visible = true;
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    pre_insertar(mail, usuario, gspnombre) {
      this.titulo = "Agregar Tarea";
      this.mensajeValidacionCampo = {};
      return apiActividades
        .pre_insertarProcedimiento(mail, usuario, gspnombre)
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          this.datosFormulario.gspnombre = "";
          this.datosFormulario.gspdescripcion = "";
          this.datosFormulario.gspclave1 = "";
          this.datosFormulario.gspclave2 = "";
          this.datosFormulario.gspclave3 = "";
          this.datosFormulario.gspiniestado = "";
          this.datosFormulario.gspiniactivi = "";
      
          this.datosFormularioEstado = response.data.festado;

          //Carga lista de tipo 
          var tiposTipo = new Array();
          var lista_tipos = response.data.tipos;
          for(var i = 0; i < lista_tipos.length; i++){
              var obj = new Object();
              obj.value = lista_tipos[i]["gsptipo"];
              obj.text = lista_tipos[i]["desc_tipo"];
              tiposTipo.push(obj);
          }
          this.valTipo = tiposTipo;
         
          this.modalAgregarProveedor = true;
          this.visible = true;
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    guardarProceso(event) {
      event.preventDefault();
      this.$Progress.start();
      
      if (this.modalEditarProceso){
        return apiActividades
        .modificarProcedimiento(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario
        )
        .then(response => {
          this.mensajeToastr({
            title: response.data.festado.resultado.titulo,
            message: this.crearError(response.data.festado, "datosFormulario"),
            type: response.data.festado.resultado.estado,
            timeout: 6000
          });
          if (response.data.festado.resultado.estado != "error") {
            this.$emit("actualizaProcesos");
            this.modalEditarProceso = false;
            this.visible = false;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
      }else if (this.modalAgregarProceso) {
        return apiActividades
        .insertarProcedimiento(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario
        )
        .then(response => {
          this.mensajeToastr({
            title: response.data.festado.resultado.titulo,
            message: this.crearError(response.data.festado, "datosFormulario"),
            type: response.data.festado.resultado.estado,
            timeout: 6000
          });
          if (response.data.festado.resultado.estado != "error") {
            this.$emit("actualizaProcesos");
            this.modalAgregarProceso = false;
            this.visible = false;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
      }

    }
    
  }
};
</script>
<style scoped>
</style>
